import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';import Input from '../../../components/input/Input';
import useGetCustomerProfile from '../../../hooks/useGetCustomerProfile';
import { validateNumberInput, numberFields } from '../../../utils/formValidations';
import { useSelector } from 'react-redux';

const emptyRow = () => ({ threshold: '', newRate: '', extraPercentDiscount: '', transactionFee: '' });

const DefaultProfileSetting = () => {

    const {
        profile,
        loading,
        error,
        setProfile,
        getDefaultProfile,
        editDefaultProfile,
        getDefaultRateAdjustments,
        updateDefaultRateAdjustments
    } = useGetCustomerProfile();

    const [oldProfile, setOldProfile] = useState({})
    const [rateRows, setRateRows] = useState([])

    const shopName = useSelector((state) => state.shop.name);

    const handleInputChange = (name, value) => {
        if (numberFields.has(name)) {
			value = validateNumberInput(value, profile[name]);
		}
        setProfile((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleUpdateDefaultProfile = async (e) => {
        try {
            const updateSuccess = await editDefaultProfile(profile)
            if(updateSuccess){
                toast.success('Default Order updated successfully!');
            }else{
                console.log(error)
                toast.error(error)
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const handleCancelButton = async () => {
        setProfile(oldProfile)
    }

    const handleRowChange = (index, field, value) => {
        setRateRows(prev => prev.map((row, i) => i === index ? { ...row, [field]: value } : row));
    };

    const handleAddRow = () => {
        setRateRows(prev => [...prev, emptyRow()]);
    };

    const handleRemoveRow = (index) => {
        setRateRows(prev => prev.filter((_, i) => i !== index));
    };

    const handleSaveRateAdjustments = async () => {
        try {
            const success = await updateDefaultRateAdjustments(
                rateRows.map(row => ({
                    ...(row.id ? { id: row.id } : {}),
                    threshold: row.threshold,
                    newRate: row.newRate !== '' ? row.newRate : null,
                    extraPercentDiscount: row.extraPercentDiscount !== '' ? row.extraPercentDiscount : null,
                    transactionFee: row.transactionFee !== '' ? row.transactionFee : null,
                }))
            );
            if (success) {
                toast.success('Rate adjustments saved!');
                const fresh = await getDefaultRateAdjustments();
                setRateRows(fresh);
            } else {
                toast.error('Failed to save rate adjustments');
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    useEffect(() => {
        const fetchDefaultProfile = async () => {
            try {
                const defaultProfile = await getDefaultProfile();
                setOldProfile(defaultProfile)
            } catch (error) {
                toast.error("Failed to fetch default order:", error);
            }
        };
        const fetchRateAdjustments = async () => {
            const rows = await getDefaultRateAdjustments();
            setRateRows(rows);
        };
        fetchDefaultProfile();
        fetchRateAdjustments();
    }, []);


    return (
    <div>
        <h2 className='text-5xl mb-4'>Default Order Setting</h2>
        <div className="space-y-12">
            <div className="border-b border-gray-900/10 pb-12">
                <h2 className="text-base font-semibold leading-7 text-gray-900">Profile</h2>
                <p className="mt-1 text-sm leading-6 text-gray-600">
                    This information will be displayed publicly so be careful what you share.
                </p>

                <div className="mt-10 grid grid-cols-10 gap-x-6 gap-y-8">
                    <Input columnSpan={2} title={'Rate สินค้า'} name={'productRate'} onChange={(value) => handleInputChange('productRate', value)} value={profile?.productRate}/>
                    <Input columnSpan={2} title={'Rate COD'} name={'codRate'} onChange={(value) => handleInputChange('codRate', value)} value={profile?.codRate}/>
                    <Input columnSpan={2} title={'Rate น้ำหนัก'} name={'weightRate'} onChange={(value) => handleInputChange('weightRate', value)} value={profile?.weightRate}/>
                    <Input columnSpan={2} title={'Rate มัดจำ'} name={'downRate'} onChange={(value) => handleInputChange('downRate', value)} value={profile?.downRate}/>
                    <Input columnSpan={2} title={'Rate การใช้บัตรเครดิต'} name={'creditRate'} onChange={(value) => handleInputChange('creditRate', value)} value={profile?.creditRate}/>
                    <Input columnSpan={2} title={'Rate เครื่องบิน'} name={'airRate'} onChange={(value) => handleInputChange('airRate', value)} value={profile?.airRate}/>
                    {shopName === 'smile' && <Input columnSpan={2} title={'ส่วนลดค่าเงิน (ปกติ +0.0245)'} name={'extraFlowDiscount'} onChange={(value) => handleInputChange('extraFlowDiscount', value)} value={profile?.extraFlowDiscount}/>}
                    {shopName === 'tama' && <Input columnSpan={2} title={'ส่วนลดค่าเงิน เป็น เปอร์เซ็นต์'} name={'extraPercentDiscount'} onChange={(value) => handleInputChange('extraPercentDiscount', value)} value={profile?.extraPercentDiscount}/>}
                    {shopName === 'tama' && <Input columnSpan={2} title={'Transaction Fee'} name={'transactionFee'} onChange={(value) => handleInputChange('transactionFee', value)} value={profile?.transactionFee}/>}
                </div>
            </div>

            <div className="border-b border-gray-900/10 pb-12">
                <h2 className="text-base font-semibold leading-7 text-gray-900">Default Rate Adjustment Thresholds</h2>
                <p className="mt-1 text-sm leading-6 text-gray-600">
                    ลูกค้าใหม่จะได้รับ threshold เหล่านี้โดยอัตโนมัติเมื่อสมัคร
                </p>

                <div className="mt-6">
                    <table className="min-w-full text-sm border border-gray-200 rounded">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-3 py-2 text-left font-medium text-gray-700">Threshold (¥)</th>
                                {shopName === 'smile' && <th className="px-3 py-2 text-left font-medium text-gray-700">New Rate</th>}
                                {shopName === 'tama' && <th className="px-3 py-2 text-left font-medium text-gray-700">Extra % Discount</th>}
                                {shopName === 'tama' && <th className="px-3 py-2 text-left font-medium text-gray-700">Transaction Fee</th>}
                                <th className="px-3 py-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rateRows.map((row, i) => (
                                <tr key={i} className="border-t border-gray-100">
                                    <td className="px-3 py-2">
                                        <input
                                            type="number"
                                            className="border border-gray-300 rounded px-2 py-1 w-32 text-sm"
                                            value={row.threshold}
                                            onChange={e => handleRowChange(i, 'threshold', e.target.value)}
                                            placeholder="e.g. 500000"
                                        />
                                    </td>
                                    {shopName === 'smile' && (
                                        <td className="px-3 py-2">
                                            <input
                                                type="number"
                                                className="border border-gray-300 rounded px-2 py-1 w-28 text-sm"
                                                value={row.newRate}
                                                onChange={e => handleRowChange(i, 'newRate', e.target.value)}
                                                placeholder="e.g. 0.27"
                                            />
                                        </td>
                                    )}
                                    {shopName === 'tama' && (
                                        <td className="px-3 py-2">
                                            <input
                                                type="number"
                                                className="border border-gray-300 rounded px-2 py-1 w-28 text-sm"
                                                value={row.extraPercentDiscount}
                                                onChange={e => handleRowChange(i, 'extraPercentDiscount', e.target.value)}
                                                placeholder="e.g. 0.02"
                                            />
                                        </td>
                                    )}
                                    {shopName === 'tama' && (
                                        <td className="px-3 py-2">
                                            <input
                                                type="number"
                                                className="border border-gray-300 rounded px-2 py-1 w-28 text-sm"
                                                value={row.transactionFee}
                                                onChange={e => handleRowChange(i, 'transactionFee', e.target.value)}
                                                placeholder="e.g. 60"
                                            />
                                        </td>
                                    )}
                                    <td className="px-3 py-2">
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveRow(i)}
                                            className="text-red-500 hover:text-red-700 text-sm"
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button
                        type="button"
                        onClick={handleAddRow}
                        className="mt-3 text-sm text-indigo-600 hover:text-indigo-500"
                    >
                        + Add threshold
                    </button>
                </div>

                <div className="mt-4 flex justify-end">
                    <button
                        onClick={handleSaveRateAdjustments}
                        className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
                    >
                        Save Rate Adjustments
                    </button>
                </div>
            </div>
        </div>

        <div className="mt-6 flex items-center justify-end gap-x-6">
            <button type="button" className="text-sm font-semibold leading-6 text-gray-900"
            onClick={handleCancelButton}>
            Cancel
            </button>
            <button
            onClick={handleUpdateDefaultProfile}
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
            Save
            </button>
        </div>
    </div>
  )
}

export default DefaultProfileSetting
